<template lang="pug">
.plan_select
  template(v-if="current_user_id == null")
    plan-interval-menu(:for_lp="true")
  template(v-else)
    plan-interval-menu(:interval="interval", :interval_count="interval_count")
  table.table.table-bordered
    thead
      tr
        th.blank(style='width: 20%;')
        th(v-for="plan in display_plans",:class="plan.name") {{plan.display_name}}
    tbody
      tr
        th 月額料金
        td(v-for="plan in display_plans")
          template(v-if="plan.name == 'free'")
            .el_price 0円
          template(v-else-if="plan.name == 'custom'")
            .el_contact
              | 設定PVにより変動
          template(v-else)
            .el_before_price(v-if="is_plan_anual || plan_interval_count!=1")
              | {{formatPriceWithoutAnual(plan.amount)}}円
              br/
              .el_arrowBottom
            .el_price {{formatPrice(plan.amount)}}円/月
      tr
        th.head_title.heatmap(:colspan="plan_count")
          | ヒートマップ
          sup ※1
      tr
        th 登録domain数
        td(v-for="(plan, index) in display_plans")
          template(v-if="plan.name=='free'") 1サイトまで
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th 登録URL数
        td(v-for="(plan, index) in display_plans")
          template(v-if="plan.name=='free'") 1URL
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th 計測可能上限PV数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 合計 1,000 PV まで
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.heatmap_imp_limit.toLocaleString()}}/月 PV
      tr
        th データ保存期間
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 30日
          template(v-else)
            i.fa.fa-check-circle {{dataPeriod(plan)}}
      tr
        th FV離脱率計測機能
        td(v-for="plan in display_plans")
          i.fa.fa-check-circle あり
      tr
        th 最終到達率計測機能
        td(v-for="plan in display_plans")
          i.fa.fa-check-circle あり
      tr
        th OS別計測機能
        td(v-for="plan in display_plans")
          i.fa.fa-check-circle あり
      tr
        th 離脱時イベント別計測機能
        td(v-for="plan in display_plans")
          i.fa.fa-check-circle あり
      tr
        th.head_title.popup(:colspan="plan_count") 離脱防止
      tr
        th.head_title(:colspan="plan_count") ウィジェット
      tr
        th ウィジェットへの広告
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 表示されます
          template(v-else="")
            i.fa.fa-check-circle なし
      tr
        th ウィジェット作成数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個まで
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th ウィジェット設置可能domain数
        td(v-for="(plan, index) in display_plans")
          template(v-if="isOneDomain(plan)")  1 domainまで
          template(v-else="")
            i.fa.fa-check-circle 無制限

      tr
        th.head_title(:colspan="plan_count") ポップアップ
      tr
        th 離脱防止ポップアップ作成数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個まで
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th 特定位置出現ポップアップ作成数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個まで
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th 特定位置出現ポップアップ設置可能domain数
        td(v-for="(plan, index) in display_plans")
          template(v-if="isOneDomain(plan)") 1 domainまで
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th 離脱防止ポップアップ設置可能domain数
        td(v-for="(plan, index) in display_plans")
          template(v-if="isOneDomain(plan)") 1 domainまで
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th カウントダウン機能
        td(v-for="(plan, index) in display_plans")
          template(v-if="hasCountdown(plan)")
            i.fa.fa-check-circle あり
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle あり
          template(v-else="")
            | なし
      tr
        th.head_title(:colspan="plan_count") オーバーレイ
      tr
        th オーバーレイ作成数
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 1個まで
          template(v-else)
            i.fa.fa-check-circle 無制限
      tr
        th オーバーレイ設置可能domain数
        td(v-for="(plan, index) in display_plans")
          template(v-if="isOneDomain(plan)") 1 domainまで
          template(v-else="")
            i.fa.fa-check-circle 無制限
      tr
        th.head_title(:colspan="plan_count")
          | クリエイティブ合計上限PV
          sup ※2
      tr
        th ウィジェット
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 無制限 (広告表示あり)
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.widget_imp_limit.toLocaleString()}}/月 PV

      tr
        th ポップアップ
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 合計 1,000 PV まで
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.pop_up_imp_limit.toLocaleString()}}/月 PV
      tr
        th オーバーレイ
        td(v-for="plan in display_plans")
          template(v-if="plan.name=='free'") 合計 1,000 PV まで
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle 無制限/月
          template(v-else)
            i.fa.fa-check-circle {{plan.overlay_imp_limit.toLocaleString()}}/月 PV
      tr
        th.head_title(:colspan="plan_count") クレジット表記
      tr
        th 「Powerd By SiteLead」表記
        td(v-for="(plan, index) in display_plans")
          template(v-if="isMoreMaster(plan)")
            i.fa.fa-check-circle なし
          template(v-else-if="plan.name=='custom'")
            i.fa.fa-check-circle なし
          template(v-else="") あり
      template(v-if="current_user_id == null")
        tr
          th.blank
          td.text-center(v-for="(plan, index) in display_plans")
            template(v-if="plan.name=='custom'")
              a.el_btnBase.el_btnPlanRegister.keyframe.animation(href="/pages/contact",:class="plan.name")
                i.fa.fa-angle-right
                | 問い合わせ
            template(v-else)
              a.el_btnBase.el_btnPlanRegister.keyframe.animation(@click="sign_up( $event, plan )",href="#",:class="plan.name")
                i.fa.fa-angle-right
                | 申し込む
      template(v-else)
        tr(v-if="!no_button && !invoice_failed")
          th.blank
          td.text-center(v-for="(plan, index) in display_plans")
            template(v-if="isSamePlan(plan)")
              template(v-if="isSamePayCircle()")
                button.btn.btn-default 現在のプラン
              template(v-else-if="plan.name == 'free'")
                button.btn.btn-default 現在のプラン
              template(v-else)
                button.btn.btn-default(@click="upgrade( plan )") 支払期間変更
            template(v-else-if="isLowerPlan(plan)")
              template(v-if="index!=0")
                button.btn.btn-secondary(@click="downgrade( plan )") ダウングレード
              template(v-else)
                button.btn.btn-secondary(@click="cancelPlan") ダウングレード
            template(v-else-if="isUpperPlan(plan)")
              button.btn.btn-primary(@click="upgrade( plan )") アップグレード
            template(v-else-if="plan.name == 'custom'")
              a.btn.btn-primary(href="/users/plans/custom") 設定ページへ
</template>

<script>

import { mapState } from 'vuex'

import { required, url } from 'vuelidate/lib/validators'

import Vue from 'vue'

import StrMixin from '../mixins/str'

import PlanIntervalMenu from '../components/plan_interval_menu.vue'

export default {
  props: {
    plans: { type: String, default: [] },
    no_button: { type: Boolean, default: false },
    plan_interval_name: {type: String, default: "month"},
    current_plan_name: { type: String, default: "free" },
    current_plan_id: { type: String, default: null },
    has_stripe_customer_id: { type: Boolean, default: null },
    invoice_failed: { type: Boolean, default: false },
    is_upgrade: { type: Number, default: 0, require: false },
    hide_above_idx: { type: Number, default: 0, require: false },
    no_button: { type: Boolean, default: false },
    interval: { type: String, default: "month" },
    interval_count: { type: String, default: "1" },
    is_anual: { type: Boolean, default: false },
    current_user_id: { type: String, default: null },
  },
  data(){
    return {
      plans_arr: [],
    }
  },
  components: {
    PlanIntervalMenu
  },
  methods: {
    sign_up(e, plan){
      e.preventDefault()
      if(this.$store.state.user.is_anual){
        location.href="/plan_redirect/"+plan.name+"?anual=1"
      } else {
        if(this.plan_interval_count == 6){
          location.href="/plan_redirect/"+plan.name+"?interval_count=6"
        } else if(this.plan_interval_count == 3){
           location.href="/plan_redirect/"+plan.name+"?interval_count=3"
        } else {
          location.href="/plan_redirect/"+plan.name
        }
      }
    },
    isOneDomain(plan){
      if(
        plan.name=="free" ||
        plan.name=="basic"
      ){
        return true
      } else {
        return false
      }
    },
    hasCountdown(plan){
      if(
        plan.name=="master" ||
        plan.name=="enterprise" ||
        plan.name=="1m_pv" ||
        plan.name=="2m_pv"
      ){
        return true
      } else {
        return false
      }
    },
    isMoreMaster(plan){
      if(
        plan.name=="master" ||
        plan.name=="enterprise" ||
        plan.name=="1m_pv" ||
        plan.name=="2m_pv"
      ){
        return true
      } else {
        return false
      }
    },
    dataPeriod(plan){
      if(
        plan.name=="custom" ||
        plan.name=="enterprise" ||
        plan.name=="1m_pv" ||
        plan.name=="2m_pv"
      ){
        return "365日"
      } else {
        return "180日"
      }
    },
    formatPrice(number){
      if(this.is_plan_anual){
        return (number*0.6).toLocaleString('ja-JP')
      } else {
        if(this.plan_interval_count == 6){
          return (number*0.7).toLocaleString('ja-JP')
        } else if(this.plan_interval_count == 3){
          return (number*0.8).toLocaleString('ja-JP')
        } else{
          return number.toLocaleString('ja-JP')
        }
      }
    },
    formatPriceWithoutAnual(number){
      return number.toLocaleString('ja-JP')
    },
    setAnual(){
      this.$store.commit("user/setIsAnual", true)
    },
    setMonthly(interval_count){
      this.$store.commit("user/setIsAnual", false)
      this.$store.commit("user/setIntervalCount", interval_count)
    },
    removeAnual(){
      this.$store.commit("user/setIsAnual", false)
    },
    upgrade(plan){
      this.$store.commit("user/setPlanToChange", plan)
      if(this.has_stripe_customer_id == false){
        this.$bvModal.show('set-user-credit-card')
      } else {
        this.$bvModal.show('change-user-plan')
      }
    },
    downgrade(plan){
      this.$store.commit("user/setPlanToChange", plan)
      this.$bvModal.show('change-user-plan')
      //this.resetCurrentPlanIdx(plan.name)
    },
    cancelPlan(){
      this.$bvModal.show('cancel-user-plan')
      //this.resetCurrentPlanIdx("free")
    },
    isUpperPlan(plan){
      return this.$store.getters["user/is_upper_plan"](plan)
    },
    isLowerPlan(plan){
      return this.$store.getters["user/is_lower_plan"](plan)
    },
    isSamePlan(plan){
      return this.$store.getters["user/is_same_plan"](plan)
    },
    isSameId(plan){
      return this.$store.getters["user/is_same_id"](plan)
    },
    isSamePayCircle(){
      console.log("this.is_plan_anual", this.is_plan_anual)
      console.log("this.is_anual", this.is_anual)

      console.log("this.plan_interval_count", this.plan_interval_count)
      console.log("this.interval_count", this.interval_count)

      return ( this.is_plan_anual == this.is_anual ) &&  ( this.plan_interval_count == this.interval_count )
    }
  },
  mixins:[StrMixin],
  watch: {
    '$store.state.user.plan_name': function (val) {
      this.$store.dispatch("user/updateCurrentPlanIdx")
    },
  },
  computed: {
    plan_name(){
      return this.$store.state.user.plan_name
    },
    plan_count(){
      return this.display_plans.length+1
    },
    display_plans(){
      return this.$store.getters["user/display_plans_for_lp"]
    },
    is_plan_anual(){
      return this.$store.state.user.is_anual
    },
    plan_interval_count(){
      return this.$store.state.user.interval_count
    }
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("user/setPlansArr", JSON.parse(this.plans))
    if(this.current_user_id==null){
      this.$store.commit("user/setIsAnual", true)
    }

    this.$store.commit("user/setPlanId", this.current_plan_id)
    this.$store.commit("user/setHideAboveIdx", this.hide_above_idx)
    this.$store.commit("user/setPlanIntervalName", this.plan_interval_name)
    if(this.is_upgrade==0){
      this.$store.commit("user/pushPlansArrForLp", {name: "free", display_name: "Free", amount: 0, widget_imp_limit: 0, pop_up_imp_limit: 0, overlay_imp_limit: 0})
    }
    this.$store.commit("user/setPlanName", this.current_plan_name)
    this.$store.commit("user/unshiftPlansArrForLp", {name: "custom", display_name: "Custom", amount: 0, widget_imp_limit: 0, pop_up_imp_limit: 0, overlay_imp_limit: 0})

  },
}
</script>
<style lang="scss" scoped>
.callout{
  a{
    color:white;
    text-decoration:none;
  }
}
table{
  // th.head_title{
  //   background: #f1f1f1;
  //   padding:0.5rem 0.75rem;
  //   &.heatmap{
  //     padding:1rem 0.75rem;
  //     background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #0080ff, #00b2b5);
  //     color: white;
  //   }
  //   &.popup{
  //     padding:1rem 0.75rem;
  //     background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #dc3545, #ff7838);
  //     color: white;
  //   }
  // }
    .heatmap{
    background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #0080ff, #00b2b5);
    color: white;
    vertical-align: middle;
  }
  .popup{
    background: url(/images/hero_bg_pattern.png), linear-gradient(135deg, #dc3545, #ff7838);
    color: white;
    vertical-align: middle;
  }
  .widget{
    background: url(/images/hero_bg_pattern.png), linear-gradient(rgb(255, 170, 0), #f1d04e);
    color: white;
    vertical-align: middle;
  }
  th.empty{
    border: none;
    background: #ffff;
    padding:0.5rem 0.75rem;
  }
}
</style>
